module.exports = __webpack_public_path__ + "img/Doc07-20100094-003_cover.fa7bcc76.jpg";